module.exports = __webpack_public_path__ + "static/assets/5058eeeeb8578af068166ded18d6ad98.png";